const SITE_KEY =
  "6Leb1M4rAAAAAP_gRcAyMiOo99-j6eqQajKuMlB9";

export const obtenerRecaptcha = async () => {
  return new Promise((resolve, reject) => {

    if (!window.grecaptcha) {
      reject(
        new Error(
          "reCAPTCHA todavía no está disponible."
        )
      );

      return;
    }

    window.grecaptcha.ready(() => {

      window.grecaptcha
        .execute(SITE_KEY, {
          action: "consultar_cedula",
        })
        .then((token) => {
          resolve(token);
        })
        .catch((error) => {
          console.error(
            "Error obteniendo reCAPTCHA:",
            error
          );

          reject(error);
        });

    });
  });
};
